import { makeStyles } from '@material-ui/core/styles';

export const useResponsiveCallToActionStyles = makeStyles((theme) => ({
  callToActionBodyStyle: {
    marginBottom: theme.spacing(3),
    maxWidth: 600,
  },
  callToActionHeaderStyle: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(1),
  },
  callToActionImageStyle: {
    display: 'block',
    height: 'auto',
    marginRight: 'auto',
    maxWidth: 300,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      marginLeft: 'auto',
      marginRight: 'initial',
      maxWidth: 400,
    },
  },
  callToActionImageStyleLarge: {
    maxWidth: 400,
  },
  callToActionImageStyleSmall: {
    maxWidth: 225,
  },
  callToActionRootStyle: {
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row-reverse',
    },
  },
}));
